export default __webpack_public_path__ + "static/CIHLogo-2baa12c4823fac178d337e8cf35aa456.jpg";